export class ContractFilterType {
  name: string;
  selected: boolean;
  display: boolean;

  constructor(name: string, selected: boolean = false, display = true) {
    this.name = name;
    this.selected = selected;
    this.display = display;
  }
}

export class ContractFilterGroupType {
  name: string;
  selected: boolean;
  batch: ContractFilterType[];

  constructor(name: string, selected: boolean = false, batch: ContractFilterType[] = []) {
    this.name = name;
    this.selected = selected;
    this.batch = batch;
  }
}
